// File: client_serena/src/api/updatePreferences.js

import { getAuth } from "firebase/auth";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const updatePreferences = async (updates) => {
const auth = getAuth();
const user = auth.currentUser;

if (!user) throw new Error("User not logged in");

const token = await user.getIdToken();

const res = await fetch(`${API_BASE_URL}/api/user/update-preferences`, {
method: "POST", // ✅ must match backend
headers: {
"Content-Type": "application/json",
Authorization: `Bearer ${token}`,
},
body: JSON.stringify(updates),
});

if (!res.ok) {
const err = await res.json();
throw new Error(err.msg || "Failed to update preferences");
}

const data = await res.json();
return data.preferences; // ✅ ensures EditProfileForm works
};